import { useTranslation } from 'react-i18next';

export const ISSUE_STATES = {
  DRAFT: 'draft',
  ASSIGNED: 'assigned',
  ASSIGNMENT_REJECTED: 'assignment_rejected',
  ASSIGNMENT_REQUESTED: 'assignment_requested',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  RESOLVED: 'resolved',
};

export const ISSUE_APPROVERS_STATE = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  BYPASSED: 'bypassed',
};

export const ISSUE_VISIBILITY_STATE = {
  PROJECT_WIDE: 'project_wide',
  INTERNAL: 'internal',
  SPECIFIC_TEAMS: 'specific_teams',
};

export const ISSUE_STATE_COLORS = {
  [ISSUE_STATES.DRAFT]: 'WHITE',
  [ISSUE_STATES.ASSIGNMENT_REJECTED]: 'PINK',
  [ISSUE_STATES.ASSIGNED]: 'GRAY',
  [ISSUE_STATES.ASSIGNMENT_REQUESTED]: 'YELLOW',
  [ISSUE_STATES.IN_PROGRESS]: 'BLUE',
  [ISSUE_STATES.COMPLETED]: 'TEAL',
  [ISSUE_STATES.RESOLVED]: 'GREEN',
};

export const useIssueStatesLabels = () => {
  const { t } = useTranslation();

  return {
    [ISSUE_STATES.DRAFT]: t('issue.detail.state.draft'),
    [ISSUE_STATES.ASSIGNMENT_REJECTED]: t('issue.detail.state.assignment_rejected'),
    [ISSUE_STATES.ASSIGNMENT_REQUESTED]: t('issue.detail.state.assignment_requested'),
    [ISSUE_STATES.ASSIGNED]: t('issue.detail.state.assigned'),
    [ISSUE_STATES.IN_PROGRESS]: t('issue.detail.state.in_progress'),
    [ISSUE_STATES.COMPLETED]: t('issue.detail.state.completed'),
    [ISSUE_STATES.RESOLVED]: t('issue.detail.state.resolved'),
    DEFAULT: t('issue.detail.state.default'),
  };
};
